import CompanyLeaveSettings from "../company/screens/companyLeaveSettings";
const Onboarding = () => {
    const name = window.localStorage.getItem("4r7ur-name");
    return (
        <div
            className="fixed inset-0 z-10 overflow-y-auto bg-white top-0 left-0 w-full h-full"
        >
            <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-2xl">
                <h1 className="text-3xl font-bold text-left">
                    Welcome  {name}👋
                </h1>
                <h2 className="text-xl font-semibold text-left border-b pb-4">
                    Let's set up your company profile
                </h2>
                <div className="mt-4">
                    <CompanyLeaveSettings onboarding={true} />
                </div>
            </div>
        </div>
    )
}
export default Onboarding;